import React, { forwardRef } from 'react'

import { IconProps } from './types'

const Refresh = forwardRef<SVGSVGElement, IconProps>(
  ({ color, size, stroke, ...props }, ref) => (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 14 14"
      fill={color || 'none'}
      xmlns="http://www.w3.org/2000/svg"
      stroke={stroke || 'currentColor'}
      {...props}
    >
      <path d="M13 7C13 10.3137 10.3137 13 7 13C3.68629 13 1 10.3137 1 7C1 3.68629 3.68629 1 7 1C8.33333 1 11.3 1.7 12.5 4.5M12.5 4.5V1M12.5 4.5H9" />
    </svg>
  ),
)
Refresh.displayName = 'Refresh'

export default Refresh
